import {Injectable} from '@angular/core';
import {ObjectModal} from './object-modal';


interface ObjectsModalSelectServiceInterface {
    /**
     * Собираем все выбранные объекты в линейный массив.
     * Рекурсивно проходимся по всем объектам и дочерним элементам каждого
     */
    getSelectedObjects(array: any[]): any[];
}

@Injectable()
export class ObjectsModalSelectService implements ObjectsModalSelectServiceInterface {
    constructor() {}

    getSelectedObjects(array: ObjectModal[]) {
        if (!array) {
            return [];
        }

        const values = [];

        array.filter(item => item.selected).forEach(item => {

            if (item.wholeSelected) {

                values.push({
                    id: item.id,
                    number: item.number,
                    title: item.title,
                    parent_id: item.parent_id
                });
            } else {
                values.push(...this.getSelectedObjects(item.children));
            }

        });

        return values;
    }
}

